import { useApiQuery } from 'mf_core/query';

export function useMyBusinessMenu() {
  return useApiQuery<MyBusinessMenuItem[]>(`/shared/v1/menus/my-business`);
}

export type MyBusinessMenuItem = {
  name: string;
  openInNewTab: boolean;
  sequence: number;
  subMenu: null | MyBusinessMenuItem[];
  translationKey: string;
  url: string;
};
